module.exports = __webpack_public_path__ + "ad_roll.png";